// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:21
import { IsochroneArgs_abstract } from './../abstract/SagaBase/IsochroneArgs_abstract';
export class IsochroneArgs extends IsochroneArgs_abstract {}
